import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DateRangePicker from '../../components/elements/DateRangePicker';
import CardSummary from '../../components/fragments/CardSummary';
import ChartReport from '../../components/fragments/ChartReport';
import ChartReportTrasaction from '../../components/fragments/ChartReportTransaction/ChartReportTrasaction';
import { AppContext } from '../../contexts';
import { getUserData } from '../../utils/storage';
import { fetchBestSelling, fetchSummary } from './actions';
import styles from './styles.scoped.css';

export default function Home() {
  const { setBreadcrumbs } = useContext(AppContext);
  const dispatch = useDispatch();

  const [fromDate, setFromDate] = useState(moment().startOf('month').toDate());
  const [toDate, seToDate] = useState(moment().toDate());

  const navigate = useNavigate();
  const isLaAdmin = getUserData()?.isLinkAjaAdmin;
  useEffect(() => {
    if(isLaAdmin){
      navigate('/registrasi-merchant');
    }
  }, [isLaAdmin]);

  useEffect(() => {
    setBreadcrumbs([]);
    const startDate = moment(fromDate).format('YYYY-MM-DD');
    const endDate = moment(toDate).format('YYYY-MM-DD');
    dispatch(fetchSummary(startDate, endDate));
    dispatch(fetchBestSelling(startDate, endDate));
  }, [fromDate, toDate]);

  const onDateChanged = ({ startDate, endDate }) => {
    setFromDate(startDate);
    seToDate(endDate);
  };

  return (
    <div className={styles.root}>
      <div className={styles.filters}>
        <DateRangePicker
          endDate={toDate}
          onChange={onDateChanged}
          startDate={fromDate}
        />
      </div>
      <CardSummary />
      <ChartReportTrasaction />
      <ChartReport />
    </div>
  );
}
